import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';

export class LanInfoRecoger extends Component {
    displayName = LanInfoRecoger .name

    constructor(props) {
        super(props);
        this.state = {
            numeroGuia: props.numeroGuia, 
            token: props.token,
            idModulo: props.idModulo,
            msj_1: '',
            msj_2: '',
            msj_3: ''
        };
    }

    closeInfo = (e) => {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(e.target.value);
        }
    }

    componentDidMount() {
        let funcion = 0;//Funcion 0 correpsonde a mensajes
        fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/1/' + this.state.idModulo, {
            headers: {
                'authorizedtoken': this.state.token,
                'user': window.env.API_USER,
                'refnumber': this.state.numeroGuia
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ msj_1: data });
            });

        fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/2/' + this.state.idModulo, {
            headers: {
                'authorizedtoken': this.state.token,
                'user': window.env.API_USER,
                'refnumber': this.state.numeroGuia
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.setState({ msj_2: data });
            });

        fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/3/' + this.state.idModulo, {
            headers: {
                'authorizedtoken': this.state.token,
                'user': window.env.API_USER,
                'refnumber': this.state.numeroGuia
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.setState({ msj_3: data });
            });
      
    }

    render() {
        return (
            <div className="popUp">
                <div className="popBG"></div>
                <div className="popContent">
                    <Grid fluid className="selUbicacion">
                        <Row>
                            <Col sm={10} className="gridCol t">
                                <div className="cont">
                                    <div className="title">
                                        <img src="/media/images/informacion.png" />
                                        <label>Información importante</label>
                                    </div>
                                    <div>
                                        <img src="/media/images/Calendar.png" />
                                        <label dangerouslySetInnerHTML={{ __html: this.state.msj_1.mensaje }}></label>
                                    </div>
                                    <div>
                                        <img src="/media/images/Documento.png" />
                                        <label dangerouslySetInnerHTML={{ __html: this.state.msj_2.mensaje }}></label>
                                    </div>
                                    <div>
                                        <img src="/media/images/CheckList.png" />
                                        <label dangerouslySetInnerHTML={{ __html: this.state.msj_3.mensaje }}></label>
                                    </div>
                                    <div className="title">
                                        <input type="button" value="Ok" onClick={this.closeInfo} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </div>
        );
    }

}